import { BrandSearchFilter } from "../components/UI/reusable-components/SellerBrandPageComponents/BrandSearchFilter";
import { BrandGrid } from "../components/UI/reusable-components/SellerBrandPageComponents/BrandGrid";
import { FilterAddBardButtons } from "../components/UI/reusable-components/SellerBrandPageComponents/FilterAddBrandButtons";
import { Box, Typography } from "@mui/material";

export const SellerBrandPage = () => {

  return (
    <div>
      <div style={{ display: "flex" }}>

        <BrandGrid />
      </div>
    </div>
  );
};
